<template lang="html">
    <div id="page__routelist__report" class="center-panel">
        <md-content class="md-elevation-1" md-theme="white" v-bind:loading="progress">
            <sort-table
                v-bind:columns="tableColumns" v-model="reports" v-on:refresh="getReports" v-bind:per-page="perPage" 
                v-bind:total="reportsAmount" table-id="report-routelist" default-order="desc" default-sort="id"
                v-bind:showAddButton="false" v-bind:expandable="true"  v-bind:noBreackColumns="['traking_number', 'id']" v-bind:refreshOnCreate="false"
            >
                <template slot="buttons">
                    <z-button v-if="canPrintReport" v-on:click="printReport"> Распечатать </z-button>
                </template>

                <template slot="forwarder" slot-scope="scope"> {{ scope.item.forwarder !== null ? scope.item.forwarder.login : '' }} </template>
                <template slot="from_stock" slot-scope="scope"> {{ scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен' }} </template>
                <template slot="to_stock" slot-scope="scope"> {{ scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен' }} </template>
                <template slot="stock" slot-scope="scope"> {{ scope.item.stock ? scope.item.stock.name : 'Не установлен' }} </template>
                <template slot="date" slot-scope="scope"> {{ scope.item.date ? moment(scope.item.date).format('DD.MM.YYYY') : 'Не установленна' }} </template>
                
                <template slot="type" slot-scope="scope">
                    <span v-if="parseInt(scope.item.type) === 1"> Экспедирование </span>
                    <span v-else-if="parseInt(scope.item.type) === 2"> Внутренняя перевозка </span>
                    <span v-else> Не указан </span>
                </template>

                <template slot="driver" slot-scope="scope"> 
                    <span v-if="scope.item.driver && scope.item.driver.id"> {{ (scope.item.driver && scope.item.driver.fio) ? scope.item.driver.fio : '' }} </span>
                    <span v-if="scope.item.forwarder && scope.item.forwarder.id"> {{ (scope.item.forwarder && scope.item.forwarder.fio) ? scope.item.forwarder.fio : '' }} </span>
                </template>

                <template slot="weight" slot-scope="scope">
                    <span v-if="scope.item.weight"> {{scope.item.weight.toFixed(2)}} </span>
                    <span v-else> Не указан </span>
                </template>

                <template slot="size" slot-scope="scope">
                    <span v-if="scope.item.size"> {{scope.item.size.toFixed(2)}} </span>
                    <span v-else> Не указан </span>
                </template>

                <template slot="status" slot-scope="scope">
                    <div class="itineraries-status" v-bind:style="('color: ' + scope.item.status.color + ';')"> 
                        <span> {{scope.item.status.message}} </span>
                    </div>
                </template>

                <template slot="expanded" slot-scope="scope">
                    <div class="can-scroll report__freigts md-table-content">
                        <table class="sort-table">
                            <thead>
                                <tr>
                                    <th class="md-table-head" v-for="(column, index) in itemColumns" v-bind:key="('th-' + index)">
                                        <div class="md-table-head-container md-ripple">
                                            <div class="md-table-head-label" v-html="column.label"></div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody v-if="scope.item.freights">
                                <tr class="md-table-row" v-for="(item, i) in scope.item.freights" v-bind:key="('tr-' + scope.item.id + '-' + i)">
                                    <td class="md-table-cell" v-for="(column, index) in itemColumns" v-bind:class="{'left-margin': !index}">
                                        <div class="md-table-cell-container">
                                            <span v-if="!(['from', 'to', 'payer', 'payment_method', 'nds'].indexOf(column.field)+1)" v-bind:name="column.field" v-bind:item="item"> {{ item[column.field] }} </span>
                                            <span v-if="column.field == 'from'"  v-bind:name="column.field"> {{ (item[column.field] && item[column.field]['value']) ? item[column.field]['value'] : '' }} </span>
                                            <span v-if="column.field == 'to'"    v-bind:name="column.field"> {{ (item[column.field] && item[column.field]['value']) ? item[column.field]['value'] : '' }} </span>
                                            <span v-if="column.field == 'payer'" v-bind:name="column.field"> {{ (item[column.field] && item[column.field]['name'])  ? item[column.field]['name']  : '' }} </span>
                                            <span v-if="column.field == 'payment_method'" v-bind:name="column.field"> {{ (item[column.field] && item[column.field]['name']) ? item[column.field]['name'] : '' }} </span>
                                            <span v-if="column.field == 'nds'" v-bind:name="column.field"> {{ (item.nds) ? 'Да' : 'Нет' }} </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="md-table-row">
                                    <td class="md-table-cell" v-for="(column, index) in itemColumns" v-bind:key="('th-sum-' + index)">
                                        <div class="md-table-cell-container">
                                            <span v-if="!(['from', 'to', 'payer'].indexOf(column.field)+1)" v-bind:name="column.field" v-bind:item="scope.item.summary"> <b> {{ scope.item.summary[column.field] }} </b> </span>
                                            <span v-if="column.field == 'payer'"> <b> Сумма </b> </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable from "@/components/SortTable"
    import reportsMenu from './reports-menu';
    import ZButton from '@/components/ZButton.vue';
    export default {
        components: { SortTable, reportsMenu, ZButton },
        data() {
            return {
                tableColumns: [
                    { label: 'ID',         field: 'id',     sortable: true },          
                    { label: 'Тип', field: 'type', sortable: true},
                    { label: 'Склад экспедирования', field: 'stock', sortable: true},
                    { label: 'Водитель/Экспедитор', field: 'driver', sortable: false},
                    { label: 'Дата исполнения', field: 'date', sortable: true},
                    { label: 'Статус', field: 'status', sortable: true},
                    { label: 'Грузы', field: 'freights_count', sortable: false},
                    { label: 'Кол-во мест', field: 'seats', sortable: false},
                    { label: 'Вес (кг)', field: 'weight', sortable: false},
                    { label: 'Объём (м<sup>3</sup>)', field: 'size', sortable: false},
                    { label: '', field: 'actions'}
                ],
                itemColumns: [
                    { label: 'Треккод (документ)', field: 'traking_number'},
                    { label: 'Отправление', field: 'from'},
                    { label: 'Назначение', field: 'to'},
                    { label: 'Плательщик', field: 'payer'},
                    { label: 'НДС', field: 'nds'},
                    { label: 'Кол-во мест', field: 'seats_number'},
                    { label: 'Вес (кг)', field: 'weight'},
                    { label: 'Объём (м<sup>3</sup>)', field: 'size'},
                    { label: 'Основная сумма (руб.)', field: 'price_default'},
                    { label: 'Пункт отправления (руб.)', field: 'price_forwarding_from'},
                    { label: 'Пункт назначения (руб.)', field: 'price_forwarding_to'},
                    { label: 'Скидка (руб.)', field: 'price_discount'},
                    { label: 'Наценка (руб.)', field: 'price_markup'},
                    { label: 'Негабарит (руб.)', field: 'price_oversize'},
                    { label: 'Прочее (руб.)', field: 'price_other'},        
                    { label: 'Общая сумма (руб.)', field: 'price_full'},
                    { label: 'Способ оплаты', field: 'payment_method'},
                ],
                RLStatuses: [
                    {id: 1, label: 'Создан'},
                    {id: 2, label: 'В работе'},
                    {id: 3, label: 'Машина принята'},
                    {id: 4, label: 'Выдан на перемещение'},
                    {id: 5, label: 'Выполнен'}
                ],
                currentPage: 1,
                perPage: 50,
            }
        },
        created() {
            this.$store.commit('setTitle', 'Отчет по экспедированию');
        },
        computed: {
            /**
			 * Флаг загрузки текущего компонента
			 */
            progress() {
                return this.progressObj['get-routelist-reports'];
            },
            /**
			 * Объект флагов загрузки
			 */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
			 * Список отчетов
			 */
            reports() {
                return this.$store.state.reports.routelist_report;
            },
            /**
			 * Количество отчетов
			 */
            reportsAmount() {
                return this.$store.state.reports.routelist_report_amount;
            },
            canPrintReport() {
                if (!this.$route.query || !this.$route.query.custom_filter) return;
                let filter = JSON.parse(this.$route.query.custom_filter);
                return Object.values(filter).find(item => !!item);
            }
        },
        methods: {
            /**
			 * Получение отчетов
			 */
            getReports(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-routelist-reports');

                let filter = (this.$route.query && this.$route.query.custom_filter) ? JSON.parse(this.$route.query.custom_filter) : {};
                if (filter.date_from) filter.date_from = this.moment(filter.date_from).tz(this.$root.userTimezone).format('YYYY-MM-DD');
                if (filter.date_to)   filter.date_to   = this.moment(filter.date_to).tz(this.$root.userTimezone).format('YYYY-MM-DD');

                let data = {
                    page:       (page)      ? page      : 1, 
                    order_by:   (orderBy)   ? orderBy   : 'id', 
                    order_type: (orderType) ? orderType : 'desc',
                    count:      (count)     ? count     : 50,
                    custom_filter: filter
                };
                this.$store.dispatch('reports/getRoutelistReport', data)
                    .finally(() => this.$store.commit('hideProgressBar', 'get-routelist-reports'));
            },
            /**
			 * Печать отчета
			 */
            printReport() {
                this.printUserReport('routelist-report');
            },
            /**
			 * Метод для печати отчета
			 */
            printUserReport(type = null) {
                if (!type || !this.$route.query || !this.$route.query.custom_filter) return;
                let filter = JSON.parse(this.$route.query.custom_filter);
                if (!filter) return;

                let query = [('custom_filter=' + JSON.stringify(filter))];
                if (this.$route.query.orderBy)   query.push('order_by='   + this.$route.query.orderBy);
                if (this.$route.query.orderType) query.push('order_type=' + this.$route.query.orderType);
                
                let url = this.$store.state.endpoint + '/report/excel/' + type + '?' + query.join('&');
                window.open(url, '_blank').focus();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RoutelistReport.vue?2491bf4a